import * as React from 'react';
import { Field } from 'redux-form';

import { SegmentLabel } from '@acceligentllc/storybook';

import Checkbox from 'af-fields/Checkbox';
import Input from 'af-fields/Input';

import WorkRequestUpsertFM from '../../formModel';
import { formSectionClass, formSectionClassColumn2, formSectionClassColumn4, formSectionClassRow } from '../../helpers';
import styles from '../../styles.module.scss';

const SafetySection: React.FC = () => {
	const checkboxStyle = React.useMemo(() => [formSectionClassColumn2, styles['work-request-form__tab-content__form-section__row__centered-column']].join(' '), []);

	return (
		<div className={formSectionClass}>
			<SegmentLabel
				label="Safety"
				tooltip="All identified safety hazards and associated descriptions relevant to this job, covering environmental, physical, mechanical, and biological risks that must be assessed prior to execution."
			/>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="environmentalExposure"
						label="Environmental Exposure"
						name={WorkRequestUpsertFM.getAttributeName('environmentalExposure')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						id="environmentalExposureDescription"
						label="Description"
						name={WorkRequestUpsertFM.getAttributeName('environmentalExposureDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="respiratoryProtection"
						label="Respiratory Protection"
						name={WorkRequestUpsertFM.getAttributeName('respiratoryProtection')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						id="respiratoryProtectionDescription"
						label="Description"
						name={WorkRequestUpsertFM.getAttributeName('respiratoryProtectionDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="overheadHazards"
						label="Overhead Hazards"
						name={WorkRequestUpsertFM.getAttributeName('overheadHazards')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						id="overheadHazardsDescription"
						label="Description"
						name={WorkRequestUpsertFM.getAttributeName('overheadHazardsDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="heightWork"
						label="Height Work"
						name={WorkRequestUpsertFM.getAttributeName('heightWork')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						id="heightWorkDescription"
						label="Description"
						name={WorkRequestUpsertFM.getAttributeName('heightWorkDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="mechanicalHazards"
						label="Mechanical Hazards"
						name={WorkRequestUpsertFM.getAttributeName('mechanicalHazards')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						id="mechanicalHazardsDescription"
						label="Description"
						name={WorkRequestUpsertFM.getAttributeName('mechanicalHazardsDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="electricalHazards"
						label="Electrical Hazards"
						name={WorkRequestUpsertFM.getAttributeName('electricalHazards')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						id="electricalHazardsDescription"
						label="Description"
						name={WorkRequestUpsertFM.getAttributeName('electricalHazardsDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="hazardousMaterials"
						label="Hazardous Materials"
						name={WorkRequestUpsertFM.getAttributeName('hazardousMaterials')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						id="hazardousMaterialsDescription"
						label="Description"
						name={WorkRequestUpsertFM.getAttributeName('hazardousMaterialsDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="dangerousAnimalsOrPlants"
						label="Dangerous Animals or Plants"
						name={WorkRequestUpsertFM.getAttributeName('dangerousAnimalsOrPlants')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						id="dangerousAnimalsOrPlantsDescription"
						label="Description"
						name={WorkRequestUpsertFM.getAttributeName('dangerousAnimalsOrPlantsDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
		</div>
	);
};

export default React.memo(SafetySection);
